import Splide from "@splidejs/splide";

function initSliderJpo(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;

	root.querySelectorAll(".slider-jpo").forEach((el) => {
		const splide = new Splide(el, {
			type: "fade",
			perPage: 1,
			rewind: true,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
		});

		splide.mount();
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderJpo());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-hero", ($block) => {
		initSliderJpo($block && $block.jquery ? $block.get(0) : $block);
	});
}
